<aside
  class="relative h-full border-r border-slate200 bg-white transition-[width] duration-300 ease-in-out dark:border-slate700 dark:bg-slate800"
  [class.w-64]="!collapsed"
  [class.w-[68px]]="collapsed"
>

  <!-- Collapse toggle button (desktop only) -->
  <button
    type="button"
    (click)="toggleCollapse.emit()"
    class="absolute -right-[20px] top-6 z-50 hidden h-9 w-5 cursor-pointer items-center justify-center overflow-hidden rounded-r-lg bg-indigo500 transition-colors hover:bg-indigo600 lg:flex"
    aria-label="Toggle sidebar"
  >
    <app-icon-reusable
      [icon]="arrowIcon"
      [size]="12"
      [useCurrentColor]="true"
      [ngClass]="{ 'rotate-180 mb-1': collapsed }"
      class="text-white transition-transform duration-300"
    ></app-icon-reusable>
  </button>

  <!-- Logo / brand -->
  <!-- <div class="flex h-[54px] shrink-0 items-center gap-2.5 border-b border-slate200 px-4 dark:border-slate700">
    <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-indigo600">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9L12 2L21 9V20C21 20.5523 20.5523 21 20 21H15V15H9V21H4C3.44772 21 3 20.5523 3 20V9Z"/>
      </svg>
    </div>
    <span
      class="whitespace-nowrap text-[14px] font-semibold text-slate900 transition-all duration-300 dark:text-white"
      [class.max-w-[160px]]="!collapsed"
      [class.opacity-100]="!collapsed"
      [class.max-w-0]="collapsed"
      [class.overflow-hidden]="collapsed"
      [class.opacity-0]="collapsed"
    >Customer Portal</span>
  </div> -->

  <!-- Nav groups -->
  <nav class="flex h-full flex-col overflow-y-auto overflow-x-hidden p-2">

    <div class="flex flex-1 flex-col gap-0.5">
      @for (group of navGroups; track group.title) {
        <!-- Section heading -->
        <p
          class="overflow-hidden whitespace-nowrap px-3 text-[10px] font-medium uppercase tracking-wider text-slate400 transition-all duration-300 dark:text-slate500"
          [class.max-h-6]="!collapsed"
          [class.opacity-100]="!collapsed"
          [class.py-2]="!collapsed"
          [class.max-h-0]="collapsed"
          [class.opacity-0]="collapsed"
          [class.py-0]="collapsed"
        >{{ group.title }}</p>

        @for (item of group.items; track item.path) {
          <a
            [routerLink]="item.path"
            [routerLinkActiveOptions]="{ exact: !!item.exact }"
            routerLinkActive="bg-indigo50 !text-indigo700 dark:bg-indigo900/40 dark:!text-indigo300"
            class="flex cursor-pointer items-center rounded-lg px-3 text-slate600 transition-colors hover:bg-slate100 dark:text-slate400 dark:hover:bg-slate700"
            (click)="navigate.emit()"
            [class.w-full]="!collapsed"
            [class.gap-3]="!collapsed"
            [class.py-2.5]="!collapsed"
            [class.h-10]="collapsed"
            [class.w-10]="collapsed"
            [class.justify-center]="collapsed"
            [class.!px-0]="collapsed"
          >
            <span class="flex shrink-0 items-center justify-center">
              <app-icon-reusable [icon]="item.icon" [size]="17"></app-icon-reusable>
            </span>

            <span
              class="flex-1 whitespace-nowrap text-sm font-medium transition-all duration-300"
              [class.max-w-[160px]]="!collapsed"
              [class.opacity-100]="!collapsed"
              [class.max-w-0]="collapsed"
              [class.overflow-hidden]="collapsed"
              [class.opacity-0]="collapsed"
            >{{ item.label }}</span>

            @if (!collapsed && item.badge) {
              <span class="flex h-5 min-w-[20px] items-center justify-center rounded-full bg-indigo600 px-1.5 text-[11px] font-semibold text-white">
                {{ item.badge }}
              </span>
            }
          </a>
        }
      }
    </div>

    <!-- Footer nav items -->
    <div class="mt-auto border-t border-slate200 pt-2 dark:border-slate700">
      @for (item of footerItems; track item.path) {
        <a
          [routerLink]="item.path"
          routerLinkActive="bg-indigo50 !text-indigo700 dark:bg-indigo900/40 dark:!text-indigo300"
          class="flex cursor-pointer items-center rounded-lg px-3 text-slate600 transition-colors hover:bg-slate100 dark:text-slate400 dark:hover:bg-slate700"
          (click)="navigate.emit()"
          [class.w-full]="!collapsed"
          [class.gap-3]="!collapsed"
          [class.py-2.5]="!collapsed"
          [class.h-10]="collapsed"
          [class.w-10]="collapsed"
          [class.justify-center]="collapsed"
          [class.!px-0]="collapsed"
        >
          <span class="flex shrink-0 items-center justify-center">
            <app-icon-reusable [icon]="item.icon" [size]="17"></app-icon-reusable>
          </span>

          <span
            class="flex-1 whitespace-nowrap text-sm font-medium transition-all duration-300"
            [class.max-w-[160px]]="!collapsed"
            [class.opacity-100]="!collapsed"
            [class.max-w-0]="collapsed"
            [class.overflow-hidden]="collapsed"
            [class.opacity-0]="collapsed"
          >{{ item.label }}</span>
        </a>
      }
    </div>

  </nav>
</aside>
